import {
  Country,
  convertBoolApiToFormValue,
  MaterialProductInfoDetails,
  MaterialProductValueType,
  useApiMaterialV1MaterialProductsDetail,
} from 'api';
import { useParams } from 'react-router-dom';

import { UpdateFormValues } from '../../pages/MaterialProductDetails/MaterialProductDetails';
import { convertMaterialProductComponentAPIToMaterialComponentField } from '../../utils/convertMaterialProductComponentAPIToMaterialComponentField/convertMaterialProductComponentAPIToMaterialComponentField';

const getMaterialProductFormValues = (materialProduct: MaterialProductInfoDetails): UpdateFormValues => {
  return {
    buyer_material_component_values: convertMaterialProductComponentAPIToMaterialComponentField(
      materialProduct.material_component_values || [],
      MaterialProductValueType.BUYER
    ),
    country: materialProduct.country as Country,
    creation_process: materialProduct.creation_process || undefined,
    has_caps_and_labels: convertBoolApiToFormValue(materialProduct.has_caps_and_labels),
    is_food_grade: convertBoolApiToFormValue(materialProduct.is_food_grade),
    material_colour_id: materialProduct.material_spec.colour?.id,
    material_grade_id: materialProduct.material_grade.id,
    material_id: materialProduct.material_spec.material.id,
    material_origin_id: materialProduct.material_origin?.id,
    material_spec_id: materialProduct.material_spec.id,
    seller_material_component_values: convertMaterialProductComponentAPIToMaterialComponentField(
      materialProduct.material_component_values || [],
      MaterialProductValueType.SELLER
    ),
  };
};

export const useGetMaterialProductDetails = () => {
  const { id: materialProductId } = useParams();

  if (!materialProductId) {
    throw new Error('Material Product Id is required');
  }

  const { data: materialProductData, isLoading } = useApiMaterialV1MaterialProductsDetail(Number(materialProductId));

  return {
    data: materialProductData ? getMaterialProductFormValues(materialProductData) : undefined,
    id: materialProductId,
    isLoading: isLoading,
  };
};
